const Styles = {
  error: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    borderTop: "1px solid #777",
    borderBottom: "1px solid #777",
    padding: "12px"
  }
};

export default Styles;
